
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles, X } from "lucide-react";

const CTA2 = () => {
  const [activeModal, setActiveModal] = useState<string | null>(null);

  const openModal = (modalId: string) => {
    setActiveModal(modalId);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const handleFormSubmit = () => {
    // FormSubmit will handle the redirect, so we just close the modal
    setTimeout(() => {
      closeModal();
    }, 1000);
  };

  // JSON-LD Schema for better SEO
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Toc Rápido",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Android, iOS",
    "description": "Software de edição profissional automatizada para fotos de imóveis usando IA.",
    "offers": {
      "@type": "Offer",
      "price": "29.90",
      "priceCurrency": "BRL"
    }
  };

  return (
    <>
      {/* Adding JSON-LD schema for search engines */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      
      <section className="py-16 md:py-24 bg-gradient-to-br from-toctoc-blue to-blue-700 text-white">
        <div className="container max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
            Tecnologia que valoriza sua imagem. <br className="hidden md:block" />
            E potencializa seus resultados.
          </h2>
          <p className="text-xl opacity-90 mb-10 max-w-3xl mx-auto">
            Comece hoje mesmo a apresentar seus imóveis com qualidade profissional e economizar horas de trabalho.
            Fotografia imobiliária de alto padrão acessível para todos os corretores.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto justify-center">
            <Button 
              size="lg" 
              variant="default" 
              className="bg-white text-toctoc-blue hover:bg-white/90 px-8 py-6 text-base font-semibold rounded-full transition-transform hover:scale-105 duration-200 shadow-lg"
              aria-label="Baixar aplicativo para edição de fotos imobiliárias"
              onClick={() => openModal('modal-app-cta2')}
            >
              Baixar Aplicativo Toc Toc IA
              <Sparkles className="ml-2 h-5 w-5 text-toctoc-orange" />
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-white hover:bg-white/10 px-8 py-6 text-base font-semibold rounded-full transition-transform hover:scale-105 duration-200 text-slate-50"
              aria-label="Assinar plano Toc Toc CRM para corretores"
              onClick={() => openModal('modal-crm-cta2')}
            >
              Assinar e Acessar CRM Toc Toc
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
          
          {/* Additional content for keyword optimization */}
          <div className="mt-10 text-white/80 text-sm max-w-2xl mx-auto">
            <p>
              Toc Rápido - A solução definitiva para corretores que buscam destaque no mercado imobiliário.
              Edição de fotos imobiliárias com IA, app para corretores, fotografia profissional para imóveis.
            </p>
          </div>
        </div>
      </section>

      {/* Modal para Baixar App */}
      {activeModal === 'modal-app-cta2' && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={closeModal}>
          <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-toctoc-black">Baixar App Toc Toc IA</h2>
              <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">
                <X className="h-5 w-5" />
              </button>
            </div>
            <form 
              action="https://formsubmit.co/toctoctecnologia@gmail.com" 
              method="POST"
              onSubmit={handleFormSubmit}
              className="space-y-4"
            >
              <input 
                name="name" 
                type="text" 
                placeholder="Nome completo" 
                required 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
              />
              <input 
                name="phone" 
                type="tel" 
                placeholder="Telefone" 
                required 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
              />
              <input 
                name="email" 
                type="email" 
                placeholder="E-mail" 
                required 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
              />
              <input name="plano" type="hidden" value="Download App Toc Toc IA" />
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_template" value="box" />
              <button 
                type="submit" 
                className="w-full bg-toctoc-orange hover:bg-toctoc-orange/90 text-white py-2 px-4 rounded-md font-semibold transition-colors"
              >
                Baixar Agora
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Modal para CRM */}
      {activeModal === 'modal-crm-cta2' && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={closeModal}>
          <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-toctoc-black">Assinar CRM Toc Toc</h2>
              <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">
                <X className="h-5 w-5" />
              </button>
            </div>
            <form 
              action="https://formsubmit.co/toctoctecnologia@gmail.com" 
              method="POST"
              onSubmit={handleFormSubmit}
              className="space-y-4"
            >
              <input 
                name="name" 
                type="text" 
                placeholder="Nome completo" 
                required 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
              />
              <input 
                name="phone" 
                type="tel" 
                placeholder="Telefone" 
                required 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
              />
              <input 
                name="email" 
                type="email" 
                placeholder="E-mail" 
                required 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
              />
              <input name="plano" type="hidden" value="CRM Toc Toc" />
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_template" value="box" />
              <button 
                type="submit" 
                className="w-full bg-toctoc-blue hover:bg-toctoc-blue/90 text-white py-2 px-4 rounded-md font-semibold transition-colors"
              >
                Assinar Agora
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default CTA2;
